// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"21da0b2f","36":"0b6ebcfe","64":"44d2aecb","80":"8c1037eb","304":"44d19344","325":"269e3858","375":"818fba4d","482":"0160bbde","495":"ec551379","519":"4e259cf7","603":"4e40bcfb","619":"8e3df6a5","742":"cc869271","892":"8b167147","907":"0450edc1"}[chunkId] + ".chunk.js";
};